import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLanguage } from "../i18n";

const EASE = [0.22, 1, 0.36, 1];

const Testimonials = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 sm:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 text-center">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, ease: EASE }}
            className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#C85A32]"
          >
            {t.testimonials.eyebrow}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.08, ease: EASE }}
            className="font-serif text-4xl font-black tracking-tight text-[#0D1B2A] sm:text-5xl"
          >
            {t.testimonials.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.16, ease: EASE }}
            className="mx-auto mt-4 max-w-xl text-base text-[#0D1B2A]/60"
          >
            {t.testimonials.sub}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {t.testimonials.items.map((item, i) => (
            <motion.figure
              key={item.name}
              data-testid={`testimonial-card-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: EASE }}
              className="relative flex flex-col rounded-3xl border border-[#E6DEC8] bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#C85A32]/50 hover:shadow-2xl hover:shadow-[#C85A32]/10"
            >
              <Quote size={40} className="absolute right-7 top-7 text-[#F2E8D5]" fill="currentColor" />
              <div className="mb-5 flex gap-1" aria-label="5/5">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} size={16} className="fill-[#F2A33C] text-[#F2A33C]" />
                ))}
              </div>
              <blockquote className="flex-1 font-serif text-lg italic leading-relaxed text-[#0D1B2A]/85">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3.5">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#1B6B93] font-serif text-base font-bold text-white">
                  {item.name.replace(/^Mª\s*/, "M").charAt(0)}
                </span>
                <span className="leading-tight">
                  <span className="block text-sm font-bold text-[#0D1B2A]">{item.name}</span>
                  <span className="block text-xs font-medium text-[#C85A32]">{item.town}</span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
